import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import { Field } from "react-final-form";
import { translate } from "Translate";

export const RenderCheckbox = ({ input, label, dataTestId }) => (
    <Checkbox
        label={label}
        checked={input.value ? true : false}
        onChange={input.onChange}
        color="primary"
        style={{
            color: "#153862",
            paddingLeft: "inherit"
        }}
        inputProps={{
            "data-testid": dataTestId
        }}
    />
);
export const Error = ({ name, className, value, dataTestId }) => (
    <Field
        name={name}
        subscription={{ touched: true, error: true }}
        render={({ meta: { touched, error } }) =>
            touched && error && !value ? (
                <div value={value} className={className} data-testid={dataTestId}>
                    {error}
                </div>
            ) : null
        }
    />
);
export const LinkLabel = ({ children, termsCondition, country, language, className, ...rest }) => {
    const langVal = {
        en: "EN",
        zh: "CH"
    };

    const lang = country ? country.toUpperCase() + "_" + langVal[language] : "";

    return (
        <a
            className={`link-terms ${className}`}
            href={termsCondition ? translate("terms_conditions_link", { lang }) : translate("privacy_policy_link")}
            target="_blank"
            {...rest}
        >
            {children}
        </a>
    );
};



// WEBPACK FOOTER //
// ./src/components/StartContainer/TermsPrivacyField/Elements.js